var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16683 11.7183V16.6667H10.8335V11.7183C14.1218 12.1283 16.6668 14.9333 16.6668 18.3333H3.3335C3.33352 16.7095 3.92615 15.1415 5.00017 13.9236C6.07418 12.7056 7.55575 11.9215 9.16683 11.7183ZM10.0002 10.8333C7.23766 10.8333 5.00016 8.59584 5.00016 5.83334C5.00016 3.07084 7.23766 0.833344 10.0002 0.833344C12.7627 0.833344 15.0002 3.07084 15.0002 5.83334C15.0002 8.59584 12.7627 10.8333 10.0002 10.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessOwner);
export default __webpack_public_path__ + "static/media/business-owner.ab0810db8e597d4974c74119d0801c94.svg";
export { ForwardRef as ReactComponent };